import { useEffect, useState } from 'react';
import { Modal, Input } from 'antd';

// Per-line narration (custom text for proforma / invoice print). Stored on the
// line's `narration` field.
export default function NarrationModal({ open, onClose, value, onSave }) {
  const [text, setText] = useState('');
  useEffect(() => { if (open) setText(value || ''); }, [open, value]);
  return (
    <Modal title="📝 Narration" open={open} onCancel={onClose} onOk={() => onSave(text.trim())} okText="Save" width={480} destroyOnClose>
      <Input.TextArea rows={6} value={text} onChange={(e) => setText(e.target.value)}
        placeholder={'Custom text for proforma & invoice print…\n\nExample: Supply and installation of 12mm clear toughened glass partition as per approved drawing.'} />
      <div className="text-right text-xs text-slate-400 mt-2">{text.length} chars</div>
    </Modal>
  );
}
